export default class ChecklistTemplatesWebService {
    constructor($sbRequest, API_VERSION) {
        "ngInject";
        this.$sbRequest = $sbRequest;
        this.API_VERSION = API_VERSION;
    }

    /**
     * This endpoint returns a list representation of the project checklist template.
     *
     * @param projectId {string}    UUID
     */
    getCollection(projectId) {
        const endpointUrl = `/api/${this.API_VERSION}/api/projects/${projectId}/checklist-templates`;
        return this.$sbRequest.json({
            url: endpointUrl,
            method: "GET",
        });
    }

    /**
     * This endpoint returns a list representation of the project checklist templates from the v2 API.
     *
     * @param projectId {string}    UUID
     */
    getCollectionV2(projectId) {
        const endpointUrl = `/api/v2/projects/${projectId}/checklist-templates`;
        return this.$sbRequest.json({
            url: endpointUrl,
            method: "GET",
        });
    }

    /**
     * This endpoint returns the checklist template by id.
     *
     * @param projectId {string}    UUID
     * @param checklistTemplateId {integer}    The unique identifier of the checklistTemplate you are requesting a resource for.
     */
    get(projectId, checklistTemplateId) {
        const endpointUrl = `/api/${this.API_VERSION}/api/projects/${projectId}/checklist-templates/${checklistTemplateId}`;
        return this.$sbRequest.json({
            url: endpointUrl,
            method: "GET",
        });
    }

    /**
     * This endpoint creates a new checklist template in the project.
     *
     * @param projectId {string}    UUID
     *
     * @param body {Object}    Request body
     * @param body.name {string}    User defined name of the checklist template.
     * @param body.checklist_items {array}    List of checklist items. It's important the order of items in the array
     */
    create(projectId, { name, checklist_items }) {
        const endpointUrl = `/api/${this.API_VERSION}/api/projects/${projectId}/checklist-templates`;
        return this.$sbRequest.json({
            url: endpointUrl,
            method: "POST",
            body: { name, checklist_items },
        });
    }

    /**
     * This endpoint allows to update some properties.
     *
     * @param projectId {string}    UUID
     * @param checklistTemplateId {integer}    The unique identifier of the checklistTemplate you are requesting a resource for.
     *
     * @param body {Object}    Request body
     * @param body.name {string}    User defined name of the checklist template.
     * @param body.checklist_items {array}    List of checklist items
     */
    update(projectId, checklistTemplateId, { name, checklist_items }) {
        const endpointUrl = `/api/${this.API_VERSION}/api/projects/${projectId}/checklist-templates/${checklistTemplateId}`;
        return this.$sbRequest.json({
            url: endpointUrl,
            method: "PUT",
            body: { name, checklist_items },
        });
    }

    /**
     * This endpoint allows to remove a checklist template AND all it's children.
     *
     * @param projectId {string}    UUID
     * @param checklistTemplateId {integer}    The unique identifier of the checklistTemplate you are requesting a resource for.
     */
    delete(projectId, checklistTemplateId) {
        const endpointUrl = `/api/${this.API_VERSION}/api/projects/${projectId}/checklist-templates/${checklistTemplateId}`;
        return this.$sbRequest.json({
            url: endpointUrl,
            method: "DELETE",
        });
    }
}
